import { render } from "./UserSettings.vue?vue&type=template&id=199f49e0"
import script from "./UserSettings.vue?vue&type=script&lang=ts"
export * from "./UserSettings.vue?vue&type=script&lang=ts"
script.render = render

export default script